/* eslint-disable react/jsx-one-expression-per-line */
import { HStack, Text } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { QuestionnaireTemplateListResponse } from '../../questionnaireTemplate.types';
import { LocaleBadge } from '../LocaleBadge';

interface Props {
  row: QuestionnaireTemplateListResponse;
  onQuestionnaireTemplateModalOpen: (template: QuestionnaireTemplateListResponse) => void;
}

const TemplateNameCell: React.FC<Props> = ({ row, onQuestionnaireTemplateModalOpen }) => {
  const language = row?.questionLocale;
  const { t } = useTranslation('administration');
  return (
    <HStack cursor="pointer" onClick={() => onQuestionnaireTemplateModalOpen(row)}>
      <Text fontSize="14px" color="gray.700" fontWeight="400" _hover={{ textDecoration: 'underline' }}>
        {row.name}
        {row.default && (
          <Text as="span" fontSize="14px" color="gray.700" ml={1} fontStyle="italic" data-testid="default-template">
            ( {t('questionnaireTemplate.defaultTemplate')})
          </Text>
        )}
      </Text>
      <LocaleBadge locale={language} />
    </HStack>
  );
};

export default TemplateNameCell;
